import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=f2646fdc&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/notice.css?vue&type=style&index=0&id=f2646fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2646fdc",
  null
  
)

export default component.exports